import commaNumber from 'comma-number'

const numberFormat = (amount, suffix, bindWith = ', ') => {
  const number = Number(amount)
  const format = commaNumber.bindWith(bindWith)
  return `${format(number)} ${suffix ? suffix : ''}`
}

export default numberFormat
